<template>
    <div class="autocomplete-container">
        <autocomplete
            :id="id"
            :required="true"
            :accessibility-label="trans('birthcity')"
            :instance-id="uniqueId"
            :is-input-cleared-after-selection="false"
            :suggestions="results"
            @search-change="updateSearch"
            @input="selectValue"
            :has-unique-location="true"
            :default-selected-value="internalSelectedLocation"
            name="birthcity"
            :is-valid="isValid"
        />
    </div>
</template>

<script>

import Autocomplete from "@/components/autocomplete/Autocomplete.vue";

import { v4 as uuidv4 } from "uuid";

import { debounce } from "@/utils/utils.js";

import axios from "axios";

export default {
    name: "LocationAutocomplete",
    components: {
        "Autocomplete": Autocomplete
    },
    props: {
        isValid: {
            type: Boolean,
            required: false,
            default: true
        },
        id: {
            type: String,
            required: true
        },
        selectedLocation: {
            type: String,
            required: false,
            default: null
        }
    },
    data () {
        return {
            results: [],
            internalSelectedLocation: {
                "title": this.selectedLocation,
                "value": this.selectedLocation

            },
            uniqueId: uuidv4(),
        };
    },
    mounted: function() {
        if (this.internalSelectedLocation) {
            this.fetchData(this.internalSelectedLocation.title);
        }
    },
    methods: {
        updateSearch(value) {
            if (value) {
                this.fetchData(value);
            }
        },
        fetchData: debounce(async function(query) {
            const apikey = process.env.VUE_APP_HERE_API_KEY;
            const lang = this.$i18n.locale;

            const url = `https://autosuggest.search.hereapi.com/v1/autosuggest?q=${query}&apiKey=${apikey}&at=0,0&limit=20&lang=${lang}&locationattributes=adminInfo,timeZone`;

            // https://reverse.geocoder.ls.hereapi.com/6.2/reversegeocode.json?mode=retrieveAreas&prox=50.82088584158347,%204.378228625375898&gen=9&apiKey=WCYYudAQ3B34JZQkQRvgA126HfJGrZcVPL8V_Ifh9iY&locationattributes=adminInfo,timeZone

            const response = axios({
                method: "GET",
                url: url
            }).then(res => {
                this.results = res.data.items.filter(result => {
                    return result.resultType === "locality" && result.localityType === "city";
                }).slice(0, 5);
            }).catch(e => {
                this.results = [];
                if (e.response) {
                    return e.response;
                }
                return false;
            });


        }, 100),
        selectValue(value) {
            this.$emit("change", value);
            this.internalSelectedLocation = value;
        }
    }
};
</script>

